module.exports = __webpack_public_path__ + "img/slide-2.2322bde9.png";